import React, { useEffect, useState } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGenerator } from '../../helper/FormGenerator';
import { PageList, FormLayout } from '../../components/PageComponents';
import { usePageAPI } from '../../hooks/usePageAPI';
import Head from '../layouts/Head';
import LoadingDashboardContent from '../../components/LoadingDashboardContent';
import CartModal from '../../components/Modal/CartModal';
import WishlistModal from '../../components/Modal/WishlistModal';

const AdminWishlist = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { fetchPages, fetchPage, createPage, updatePage, deletePage } = usePageAPI();
  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchBy, setSearchBy] = useState('title');
  const [searchValue, setSearchValue] = useState('');
  const [isReload, setIsReload] = useState(false);

  const pageType = {
    isNew: pathname.includes('new'),
    isEdit: pathname.includes('edit'),
    isList: !(pathname.includes('new') || pathname.includes('edit')), 
  };

  useEffect(() => {
    const params = new URLSearchParams(search);
    const page = Number(params.get('page')) || 1;
    const limit = Number(params.get('limit')) || 20;
    const searchBy = params.get('searchBy') || 'title';
    const searchValue = params.get('searchValue') || '';

    setCurrentPage(page);
    setLimit(limit);
    setSearchBy(searchBy);
    setSearchValue(searchValue);

    if (pageType.isList) {
      fetchPages({
        type: 'wishlist/all',
        limit: limit,
        currentPage: page,
        searchBy: searchBy,
        searchValue: searchValue,
        setLoading: setLoading,
        setProgress: setProgress
      }).then(({ data, dataCount }) => {
        setPageData({
          data,
          dataCount,
        });
      });
    }
    
    if (isReload) {
      setIsReload(false);
    }
  }, [pathname, search, isReload]);

  const updateUrlParams = (page, limit, searchBy, searchValue) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    params.set('searchBy', searchBy);
    params.set('searchValue', searchValue);
    navigate({ pathname: '/admin/page/list', search: params.toString() });
  };

  return (
    <>
      <Head title={getPageTitle(pageType)} />

      {pageType.isList && (
        loading ? <LoadingDashboardContent progress={progress} /> :
          <PageList
            itemType={'wishlist'}
            itemId={'id'}
            pageTitle={'Wishlist List'}
            pageData={pageData.data}
            actionApplyKeyMap={{
              'Delete': 'delete',
            }}
            columns={[ 'Wishlist', 'Customer Name', 'Customer Email']}
            filterBy={false}
            columnKeyMap={{
              'Wishlist': (item) => <WishlistModal data={item} />,
              'Customer Name': 'user_name',
              'Customer Email': 'user_email',
            }}
            onAddNew={false}
            onView={false}
            onEdit={false}
            onDelete={false}
            totalRows={pageData.dataCount}
            updateUrlParams={updateUrlParams}
            isReload={setIsReload}
          />
      )}
    </>
  );
};

const getPageTitle = ({ isEdit, isNew }) =>
  isEdit ? "Edit Wishlist" : isNew ? "Create New Wishlist" : "Wishlist List";
export default AdminWishlist;
